/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { WhyJoinWrapper } from '../affiliate/styles'
import { Header2, Text, Button } from '../../styles/Components'
import { gsColors } from '../../styles/Variables'
import image from '../../../public/corporate-events/gs_corporate_events_why_glamsquad.jpg'
import Image from 'next/image'

const WhyGlamsquad = ({ handleClick }) => {
  return (
    <WhyJoinWrapper>
      <div className="why-content">
        <Header2 margin="0 0 44px 0" color={gsColors.cobalt}>
          Why Glamsquad?
        </Header2>
        <div className="list">
          <div className="list-item">
            <div className="check-box">
              <img src="/images/checkmark_cobalt.svg" alt="checkmark" />
            </div>
            <Text fontSize={24} margin="0 0 0 72px" color={gsColors.cobalt}>
              No event is too big or too small
            </Text>
          </div>
          <div className="list-item">
            <div className="check-box">
              <img src="/images/checkmark_cobalt.svg" alt="checkmark" />
            </div>
            <Text fontSize={24} margin="0 0 0 72px" color={gsColors.cobalt}>
              White glove service with a dedicated concierge team
            </Text>
          </div>
          <div className="list-item">
            <div className="check-box">
              <img src="/images/checkmark_cobalt.svg" alt="checkmark" />
            </div>
            <Text fontSize={24} margin="0 0 0 72px" color={gsColors.cobalt}>
              2000+ highly-experienced beauty pros
            </Text>
          </div>
          <div className="list-item">
            <div className="check-box">
              <img src="/images/checkmark_cobalt.svg" alt="checkmark" />
            </div>
            <Text fontSize={24} margin="0 0 0 72px" color={gsColors.cobalt}>
              Consistent, best-in-class service
            </Text>
          </div>
          <div className="list-item">
            <div className="check-box">
              <img src="/images/checkmark_cobalt.svg" alt="checkmark" />
            </div>
            <Text fontSize={24} margin="0 0 0 72px" color={gsColors.cobalt}>
              Available to travel anywhere upon request (connect with a
              concierge for pricing)
            </Text>
          </div>
        </div>
        <Button
          style={{ marginTop: 60 }}
          onClick={handleClick}
          target="_blank"
          outline
          large
          color={gsColors.cobalt}
        >
          Book A Corporate Event
        </Button>
      </div>
      <div className="image-placeholder why-glamsquad">
        <Image
          fill
          style={{ objectFit: 'cover ' }}
          src={image}
          alt="why-image"
          priority
          quality={100}
        />
      </div>
    </WhyJoinWrapper>
  )
}

export default WhyGlamsquad
